import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import HeaderImage from '@/components/HeaderImage';
import ContactForm from './components/ContactForm';
import DecorativeDivider from './components/DecorativeDivider';
import { contactContent } from '@/mocks/contactContent';

export default function Contact() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <HeaderImage />

      <main className="max-w-3xl mx-auto px-6 md:px-10 py-12 md:py-16">
        <h1 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-relaxed tracking-[0.15em] mb-8 text-center">
          Contact
        </h1>

        <DecorativeDivider />

        {/* Boîte 1 — Premier échange */}
        <div className="border border-accent-500/30 bg-background-50 rounded-lg p-5 md:p-7 mb-10 text-center">
          <p className="font-body font-bold text-sm md:text-base text-foreground-800 tracking-[0.15em] uppercase leading-relaxed mb-6">
            Notre premier échange me permettra de comprendre précisément le service dont vous avez besoin.
          </p>

          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-accent-500/30" />
            <div className="w-1.5 h-1.5 rounded-full bg-accent-500" />
            <div className="h-px w-12 bg-gradient-to-l from-transparent to-accent-500/30" />
          </div>

          <p className="font-heading italic font-bold text-xl md:text-2xl text-foreground-950 tracking-widest">
            Je suis à votre écoute
          </p>
        </div>

        {/* Boîte 2 — Coordonnées */}
        <div className="bg-white rounded-lg pt-2 pb-5 px-5 md:pt-3 md:pb-6 md:px-6 mb-10 text-center shadow-[0_0_16px_0_rgba(0,0,0,0.08)]">
          {/* Initiales stylisées */}
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="h-px w-16 bg-gradient-to-r from-transparent to-accent-500/40" />
            <div className="flex items-center gap-2">
              <svg width="28" height="36" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 38C16 38 8 28 8 18C8 12 11 6 16 6C21 6 24 12 24 18C24 28 16 38 16 38Z" stroke="oklch(var(--accent-500))" strokeWidth="1.5" fill="none" />
                <path d="M16 6C16 6 12 12 12 18" stroke="oklch(var(--accent-500))" strokeWidth="1" fill="none" />
                <path d="M16 6C16 6 20 12 20 18" stroke="oklch(var(--accent-500))" strokeWidth="1" fill="none" />
                <circle cx="16" cy="14" r="2" fill="oklch(var(--accent-500))" />
              </svg>
            </div>
            <div className="h-px w-16 bg-gradient-to-l from-transparent to-accent-500/40" />
          </div>

          <p className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-2 leading-tight">
            {contactContent.name}
          </p>

          <div className="flex flex-col items-center gap-1 mb-2">
            <span className="font-heading font-bold text-sm tracking-widest text-foreground-950 uppercase leading-tight">Proximité Confiance</span>
            <span className="font-heading font-bold text-xs tracking-widest text-accent-500 uppercase leading-tight">— Finistère —</span>
          </div>

          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="h-px w-8 bg-gradient-to-r from-transparent to-accent-500/30" />
            <div className="w-1 h-1 rounded-full bg-accent-500" />
            <div className="h-px w-8 bg-gradient-to-l from-transparent to-accent-500/30" />
          </div>

          <p className="font-body font-bold text-xs md:text-sm text-foreground-700 tracking-[0.2em] uppercase leading-tight mb-1">
            {contactContent.role}
          </p>

          <div className="flex items-center justify-center gap-3 my-3">
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-accent-500/30" />
            <div className="w-1.5 h-1.5 rounded-full bg-accent-500" />
            <div className="h-px w-12 bg-gradient-to-l from-transparent to-accent-500/30" />
          </div>

          <p className="font-body font-bold text-sm md:text-base text-foreground-800 tracking-wide mb-1 leading-tight">
            {contactContent.phone}
          </p>
          <p className="font-body font-bold text-[11px] md:text-sm text-foreground-700 tracking-[0.02em] uppercase leading-tight break-all px-2">
            {contactContent.email}
          </p>
        </div>

        <ContactForm />
      </main>

      <Footer />
    </div>
  );
}